import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { newsItems } from '@/mocks/news';
import { formatDate } from '@/lib/content';

export default function HomeNews() {
  const [feature, ...rest] = newsItems;

  return (
    <section className="shell py-12 md:py-16">
      <SectionHeading
        eyebrow="Latest News"
        title="最新资讯"
        description="按发布时间倒序排列，追踪动画、漫画与二次元周边的最新动态。"
        actionLabel="查看全部资讯"
        actionTo="/category/news"
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
        <Link
          to={`/detail/news/${feature.id}`}
          className="group lg:col-span-7 block rounded-lg overflow-hidden border border-background-200/80 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
            <img
              src={feature.cover}
              alt={feature.title}
              title={`${feature.title} - 琉璃神社动漫资讯`}
              className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-500"
            />
            <span className="absolute left-4 top-4 px-2.5 py-1 rounded bg-accent-500 text-primary-950 text-[11px] leading-none">
              {feature.section}
            </span>
          </div>
          <div className="p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2 text-[11px] text-secondary-500 font-label">
              <span>{formatDate(feature.date)}</span>
              <span className="w-1 h-1 rounded-full bg-background-400"></span>
              <span>{feature.author}</span>
              <span className="w-1 h-1 rounded-full bg-background-400"></span>
              <span>{feature.views.toLocaleString('en-US')} 阅读</span>
            </div>
            <h3 className="mt-3 text-lg md:text-2xl font-semibold leading-8 md:leading-9 group-hover:text-primary-700 transition-colors">
              {feature.title}
            </h3>
            <p className="mt-3 text-sm text-secondary-600 leading-7 clamp-2">{feature.summary}</p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              {feature.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded bg-secondary-100 text-[11px] text-secondary-700 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
              <span className="ml-auto inline-flex items-center gap-1 text-xs text-primary-600 whitespace-nowrap">
                阅读全文
                <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
              </span>
            </div>
          </div>
        </Link>

        <div className="lg:col-span-5 flex flex-col rounded-lg border border-background-200/80 bg-background-50 overflow-hidden">
          {rest.slice(0, 4).map((item) => (
            <Link
              key={item.id}
              to={`/detail/news/${item.id}`}
              className="group flex gap-3 md:gap-4 p-4 md:p-5 border-b border-background-200/70 last:border-0 hover:bg-background-100/70 transition-colors cursor-pointer"
            >
              <span className="shrink-0 w-[96px] h-[72px] md:w-[112px] md:h-[84px] rounded-md overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 琉璃神社动漫资讯`}
                  className="w-full h-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1 flex flex-col">
                <span className="text-[11px] text-secondary-500 font-label">{formatDate(item.date)}</span>
                <span className="mt-1.5 text-sm font-medium leading-6 text-foreground-900 group-hover:text-primary-700 transition-colors clamp-2">
                  {item.title}
                </span>
                <span className="mt-auto text-[11px] text-secondary-500 inline-flex items-center gap-1">
                  <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                  {item.views.toLocaleString('en-US')}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}